import ApiClient from './ApiClient'

const API_NAME = 'WeConnect'

const client = new ApiClient(API_NAME)

export default {
  getCondition() {
    return client.get(`/receptionist/condition`)
  },
  saveCondition(data) {
    data.revision = data.revision * 1 // 数値化

    return client.put(`/receptionist/condition`, data)
  }
}
